import { config } from '~app/config';

import { AddressSuggestionParams } from '@breezeventures/web-ph-address-suggestions/api';
import { skipToken, useQuery } from '@tanstack/react-query';

import { getAddressSuggestions } from './get-address-suggestions';

export function useAddressCoordinates({
  params,
  enabled = true,
}: {
  params: AddressSuggestionParams;
  enabled: boolean;
}) {
  return useQuery({
    queryKey: ['address-coordinates', params],
    queryFn: enabled
      ? async () => {
          return getAddressSuggestions({
            apiHost: config.apiHost ?? '',
            ...params,
          });
        }
      : skipToken,
    select: (addresses) => {
      if (addresses?.length > 0 && addresses[0].coordinates) {
        const coordinates = addresses[0].coordinates;

        return {
          lng: coordinates.longitude,
          lat: coordinates.latitude,
        };
      }

      return null;
    },
  });
}
